// extracted by mini-css-extract-plugin
export default {"loginBg":"ScreenDivider_loginBg__ZCyRJ","medic":"ScreenDivider_medic__u5HRJ","patient":"ScreenDivider_patient__3uQcj","clinic":"ScreenDivider_clinic__ZmZdW"};